class CategoryNavDropdown extends HTMLElement {
  static _sharedDropdownBound = false;

  connectedCallback() {
    this.leftCol = this.querySelector('.category-nav__left-col');
    this.rightCol = this.querySelector('.category-nav__right-col');
    this.dropdown = this.querySelector('.category-nav__dropdown');
    this.dropdownInner = this.querySelector('.category-nav__dropdown-inner');
    if (!this.leftCol || !this.rightCol || !this.dropdown) return;

    const blocks = this.leftCol.querySelectorAll('.category-nav__block');
    if (blocks.length === 0) {
      this.dropdownInner.style.display = 'none';
      return;
    }

    this._distributeBlocks();
    CategoryNavDropdown.switchPanel(this.dropdown, 0);
    this._initMobileMenu();
    this._initMobileMenuEvents();
    this._bindSharedDropdownEvents();
  }

  /**
   * PC 下拉实际渲染在 #nav-dropdown-shared 的 clone 里，事件必须委托到共享容器。
   */
  _bindSharedDropdownEvents() {
    if (CategoryNavDropdown._sharedDropdownBound) return;
    CategoryNavDropdown._sharedDropdownBound = true;

    const shared = document.getElementById('nav-dropdown-shared');
    if (!shared) return;

    shared.addEventListener('mouseover', (e) => {
      const item = e.target.closest('[data-dropdown-left-item]');
      if (!item || !shared.contains(item)) return;
      const dropdown = item.closest('.category-nav__dropdown');
      if (!dropdown) return;
      CategoryNavDropdown.switchPanel(dropdown, parseInt(item.dataset.panelIndex, 10));
    });

    shared.addEventListener('click', (e) => {
      const item = e.target.closest('[data-dropdown-left-item]');
      if (!item || !shared.contains(item)) return;
      const dropdown = item.closest('.category-nav__dropdown');
      if (!dropdown) return;
      CategoryNavDropdown.switchPanel(dropdown, parseInt(item.dataset.panelIndex, 10));
    });

    new MutationObserver(() => {
      const dropdown = shared.querySelector('.category-nav__dropdown');
      if (dropdown) {
        CategoryNavDropdown.switchPanel(dropdown, 0);
      }
    }).observe(shared, { childList: true });
  }

  _initMobileMenuEvents() {
    const mobileMenu = this.querySelector('.header-v2-mobile-menu');
    if (!mobileMenu) return;
    mobileMenu.addEventListener('click', this._handleMobileHeadingClick.bind(this));
  }

  _handleMobileHeadingClick(e) {
    const heading = e.target.closest('.header-v2-mobile-menu__heading');
    const navItem = e.target.closest('.header-v2-mobile-nav__item');

    if (!heading && !navItem) return;
    e.stopPropagation();
    let targetItem, targetHeading;

    if (heading) {
      targetItem = heading.closest('.header-v2-mobile-menu__item');
      targetHeading = heading;
    } else {
      const navTarget = navItem.getAttribute('data-mobile-nav-target');
      const mobileMenu = this.querySelector('.header-v2-mobile-menu');
      if (!mobileMenu) return;
      const allItems = mobileMenu.querySelectorAll('.header-v2-mobile-menu__item');
      const matchedItem = Array.from(allItems).find((item) => {
        const src = item.closest('.header-v2-mobile-category-source');
        return src && src.getAttribute('data-block-id') === navTarget;
      });
      if (!matchedItem) return;
      targetItem = matchedItem;
      targetHeading = matchedItem.querySelector('.header-v2-mobile-menu__heading');
    }
    if (!targetItem) return;
    const expanded = targetItem.classList.toggle('is-expanded');
    if (targetHeading) targetHeading.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  _distributeBlocks() {
    const container = this.querySelector('.category-nav__blocks-container');
    if (!container) return;

    container.querySelectorAll('.category-nav__block').forEach((block, index) => {
      const leftItem = block.querySelector(':scope > .category-nav__left-item');
      if (leftItem) {
        leftItem.dataset.panelIndex = index;
        if (index === 0) {
          leftItem.classList.add('is-active');
        }
      }
      block.dataset.panelIndex = index;
      this.leftCol.appendChild(block);
    });

    container.querySelectorAll('.category-nav__panel').forEach((panel, index) => {
      panel.dataset.panelIndex = index;
      if (index === 0) {
        panel.classList.add('is-active');
      }
      this.rightCol.appendChild(panel);
    });
  }

  static switchPanel(dropdown, index) {
    if (!dropdown || Number.isNaN(index)) return;

    dropdown.querySelectorAll('.category-nav__left-item').forEach((item) => {
      const isActive = parseInt(item.dataset.panelIndex, 10) === index;
      item.classList.toggle('is-active', isActive);
    });

    dropdown.querySelectorAll('.category-nav__panel').forEach((panel) => {
      const isActive = parseInt(panel.dataset.panelIndex, 10) === index;
      panel.classList.toggle('is-active', isActive);
    });
  }

  _initMobileMenu() {
    const sourceContainer = this.querySelector('.category-nav__blocks-container');
    const mobileMenu = this.querySelector('.header-v2-mobile-menu');
    if (!sourceContainer || !mobileMenu) return;

    const items = sourceContainer.querySelectorAll('.header-v2-mobile-menu__item');
    items.forEach((item, index) => {
      item.classList.add('is-expanded');
      item.dataset.mobileItemIndex = index;
      const heading = item.querySelector('.header-v2-mobile-menu__heading');
      if (heading) heading.setAttribute('aria-expanded', 'true');
      mobileMenu.appendChild(item);
    });

    this._initSwipers(mobileMenu);
  }

  _initSwipers(mobileMenu) {
    const swiperContainers = mobileMenu.querySelectorAll('.category-swiper');
    swiperContainers.forEach((el) => {
      if (window.Swiper && !el.swiper) {
        el.swiper = new window.Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 16,
        });
      }
    });
  }
}
customElements.define('category-nav-dropdown', CategoryNavDropdown);
